import { render } from "./no-image-available.vue?vue&type=template&id=521974d0&scoped=true&ts=true"
import script from "./no-image-available.vue?vue&type=script&lang=ts"
export * from "./no-image-available.vue?vue&type=script&lang=ts"

import "./no-image-available.vue?vue&type=style&index=0&id=521974d0&scoped=true&lang=scss"

import exportComponent from "/Users/reevoengineering/Projects/reevo/propbank/propbank-brochure-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521974d0"]])

export default __exports__